import { formatTicker } from '@toggle/toggle';
import React from 'react';

import { AssetLogoContainer } from '~/components/asset-logo-container/AssetLogoContainer';
import { Filter, FilterProps } from '~/components/filter/Filter';
import { FilterOption } from '~/components/update-filter-options/updateFilterOptions';
import { FilterGroupKeys } from '~/hooks/use-filter-actions/useFilterActions';

import styles from './FilterCompany.module.scss';

export const FilterCompany = <T extends FilterGroupKeys>({
  labels,
  ...rest
}: FilterProps<T>) => {
  const renderCustomFilterOptionLabel = (filterOption: FilterOption) => {
    if (filterOption?.entity) {
      const entity = filterOption.entity;
      const tag = formatTicker(entity);
      return (
        <div className={styles.flexRow}>
          <AssetLogoContainer entity={entity} size={20} />
          <div className={styles.flexColumn}>
            <div className={styles.title}>{tag}</div>
            <div className={styles.subtitle}>{entity.name}</div>
          </div>
        </div>
      );
    }

    return null;
  };

  return (
    <Filter labels={{ ...labels, renderCustomFilterOptionLabel }} {...rest} />
  );
};
